import Zmage from 'react-zmage'

const ScaledImg = (props)=>{
    return <Zmage className='scaledImg' alt='' src={props.src}></Zmage>
}

export default ScaledImg